import { render, staticRenderFns } from "./AppFile.vue?vue&type=template&id=3784bbb6&scoped=true&"
import script from "./AppFile.vue?vue&type=script&lang=js&"
export * from "./AppFile.vue?vue&type=script&lang=js&"
import style0 from "./AppFile.vue?vue&type=style&index=0&id=3784bbb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3784bbb6",
  null
  
)

export default component.exports